// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb_breadcrumb__2wsJf","link":"breadcrumb_link__21Fax","content":"breadcrumb_content__3Atbs","separator":"breadcrumb_separator__3Yhb1"};